import Model from '~/models/base/Model';

/**
 * class representing Entity
 * @extends Model
 */
export default class Entity extends Model {
    static _url = `${Model._url}/entities`;

    static physical_delete(params) {
        const requestUrl = `${this._url}/physicaldelete/`;
        const requestPayload = params ?? {};
        return this.api.patch(requestUrl, requestPayload);
    }

    static delete(params) {
        const requestUrl = `${this._url}/delete/`;
        const requestPayload = params ?? {};
        return this.api.patch(requestUrl, requestPayload);
    }

    static restore(params) {
        const requestUrl = `${this._url}/restore/`;
        const requestPayload = params ?? {};
        return this.api.patch(requestUrl, requestPayload);
    }

    static bulkPhysicalDelete(params) {
        const requestUrl = `${this._url}/bulk/physicaldelete/`;
        const requestPayload = { data: params ?? {} };
        return this.api.delete(requestUrl, requestPayload);
    }

    static bulkDelete(params) {
        const requestUrl = `${this._url}/bulk/delete/`;
        const requestPayload = params ?? {};
        return this.api.put(requestUrl, requestPayload);
    }

    static bulkRestore(params) {
        const requestUrl = `${this._url}/bulk/restore/`;
        const requestPayload = params ?? {};
        return this.api.put(requestUrl, requestPayload);
    }

    static involvedIncidents(type, id) {
        const requestUrl = `${this._url}/${type}/${id}/involved-incidents/`;
        return this.api.get(requestUrl);
    }

    static getCsv(exportId) {
        const requestUrl = `${this._url}/search/export/csv/download/${exportId}/`;
        return this.api.get(requestUrl);
    }

    static exportCsv(params) {
        const requestUrl = `${this._url}/search/export/csv/`;
        // noinspection UnnecessaryLocalVariableJS (tbd: nullish fallback)
        const requestPayload = params;
        return this.api.post(requestUrl, requestPayload);
    }
}
